import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'
const title = config.title

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-首页'
          }
        },
        {
          path: '/software', // 产品服务
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: title + '-产品服务'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/couponMall'
            },
            {
              path: '/software/couponMall',
              name: 'software',
              component: resolve => require(['@/view/couponMall'], resolve),
              meta: {
                title: '产品服务丨卡券商城'
              }
            },
            {
              path: '/software/welfareMall',
              name: 'software',
              component: resolve => require(['@/view/welfareMall'], resolve),
              meta: {
                title: '产品服务丨福利商城'
              }
            },
            {
              path: '/software/customerServiceHosting',
              name: 'software',
              component: resolve => require(['@/view/customerServiceHosting'], resolve),
              meta: {
                title: '产品服务丨客服托管'
              }
            },
            {
              path: '/software/aggregatedSupplyChain',
              name: 'software',
              component: resolve => require(['@/view/aggregatedSupplyChain'], resolve),
              meta: {
                title: '产品服务丨聚合供应链'
              }
            },
            {
              path: '/software/ownSupplyChain',
              name: 'software',
              component: resolve => require(['@/view/ownSupplyChain'], resolve),
              meta: {
                title: '产品服务丨自有供应链'
              }
            },
          ]
        },
        {
          path: '/aboutUs', // 关于我们
          name: 'aboutUs',
          component: resolve => require(['@/view/aboutUs'], resolve),
          meta: {
            title: title + '-关于我们'
          },
          children: [
            {
              path: '/aboutUs',
            },
            {
              path: '/aboutUs/companyintroduction',
              name: 'aboutUs',
              component: resolve => require(['@/view/CompanyIntroduction'], resolve),
              meta: {
                title: '关于我们丨公司介绍'
              }
            },
            {
              path: '/aboutUs/contactus',
              name: 'aboutUs',
              component: resolve => require(['@/view/ContactUs'], resolve),
              meta: {
                title: '关于我们丨联系我们'
              }
            },
            {
              path: '/aboutUs/jobchance',
              name: 'aboutUs',
              component: resolve => require(['@/view/JobChance'], resolve),
              meta: {
                title: '关于我们丨加入我们'
              }
            },
          ]
        },
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: title + '-新闻动态'
          }
        },
        {
          path: '/newsinformationdetail',
          name: 'newsinformationdetail',
          component: resolve => require(['@/view/NewsInformationDetail'], resolve),
          meta: {
            title: title + '-新闻详情'
          }
        },
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: title + '-公司介绍'
          }
        },
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js